import { useEffect } from "react"
import {
  getActionCableConsumer,
  releaseActionCableConsumer,
  type ActionCableSubscriptionCallbacks,
} from "~/react/utils/actionCable"

type UseActionCableOptions = {
  params: Record<string, unknown>
  callbacks?: ActionCableSubscriptionCallbacks
  enabled?: boolean
}

export const useActionCable = ({ params, callbacks, enabled = true }: UseActionCableOptions) => {
  useEffect(() => {
    if (!enabled) return

    const consumer = getActionCableConsumer()
    const subscription = consumer.subscriptions.create(params, callbacks)

    return () => {
      subscription.unsubscribe()
      releaseActionCableConsumer()
    }
  }, [enabled, params, callbacks])
}
